'use strict'

define ['./signatureBase.css'], () ->
  (RentappService, $state, $uibModal, $rootScope) ->
    restrict: "E"
    template: require("./signatureBase.jade")
    scope: { field: "=", mode: "@", stage: "="}
    link: (scope, element, attrs) ->
      scope.signType = 'draw'
      sig = scope.field.value
      
      if sig
        if sig[0] == "[" && sig[1] == "{"
          scope.signType = 'draw'
        else
          scope.signType = 'type'

      scope.openModal = () ->
        $uibModal.open
          scope: scope
          template: require("./signatureModal.jade")
          controller: require("./signatureModal.coffee")
          windowClass: 'signature-modal'
        .closed
        .then((result) ->
          if scope.field.value
            $rootScope.$broadcast('signature-updated', { 
              name: scope.field.name
            })
        )
      scope.doType = () ->
        scope.signType = 'type'
        scope.field.value = null

      scope.$on 'switch-draw', (event, data) ->
        if data.name == scope.field.name
          scope.signType = 'draw'
          scope.field.value = null



// WEBPACK FOOTER //
// ./directives/freeforms/newSignatureModal/signatureBase.coffee